import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles((theme: any) => ({
    grid: {
        composes: "grid",
        borderCollapse: "separate",
        borderSpacing: 0,
        margin: [[0, -theme.GridCellPadding]],
        "& p": {
            margin: 0,
        },
        paddingBottom: "20px",
    },
    choiceGrid: {
        composes: "choice-grid",
        width: "100%",
    },
    gridContainer: {
        float: "left",
        maxWidth: "100%",
    },
    gridBody: {
        composes: "grid__body",
        "& tr:nth-child(even) > th, tr:nth-child(even) > td": {
            borderTopStyle: "solid",
            borderTopColor: theme.ControlBorderColor,
            borderTopWidth: theme.BorderWidth,
            borderBottomStyle: "solid",
            borderBottomColor: theme.ControlBorderColor,
            borderBottomWidth: theme.BorderWidth,
            color: Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)),
            background: Mixins.alpha(theme.ControlBackground, theme.ControlAlpha),
        },
        "& tr > th:first-child, tr > td:first-child": {
            borderLeftStyle: "solid",
            borderLeftWidth: theme.BorderWidth,
            borderTopLeftRadius: Mixins.getRowCornerBorderRadius(theme.BorderRadius),
            borderBottomLeftRadius: Mixins.getRowCornerBorderRadius(theme.BorderRadius),
        },
        "& tr:nth-child(even) > th:first-child, tr:nth-child(even) > td:first-child": {
            borderLeftColor: theme.ControlBorderColor,
        },
        "& tr:nth-child(odd) > th:first-child, tr:nth-child(odd) > td:first-child": {
            borderLeftColor: "transparent",
        },
        "& tr > th:last-child, tr > td:last-child": {
            borderRightStyle: "solid",
            borderRightWidth: theme.BorderWidth,
            borderTopRightRadius: Mixins.getRowCornerBorderRadius(theme.BorderRadius),
            borderBottomRightRadius: Mixins.getRowCornerBorderRadius(theme.BorderRadius),
        },
        "& tr:nth-child(even) > th:last-child, tr:nth-child(even) > td:last-child": {
            borderRightColor: theme.ControlBorderColor,
        },
        "& tr:nth-child(odd) > th:last-child, tr:nth-child(odd) > td:last-child": {
            borderRightColor: "transparent",
        },
    },
    gridRow: {
        composes: "grid__row",
    },
    gridRowError: {
        composes: "grid__row--error",
    },
    gridSummary: {
        composes: "grid__summary",
        textAlign: "right",
        background: theme.PrimaryColor,
        border: [[theme.BorderWidth, "solid", Mixins.borderColor(theme, theme.PrimaryColor)]],
        borderBottom:
            theme.ControlAlpha === 0 && theme.BorderWidth === 0
                ? [[3, "solid", Mixins.borderColor(theme, theme.PrimaryColor)]]
                : "",
        borderRadius: Math.min(theme.BorderRadius, theme.InputHeight / 2),
        lineHeight: `${theme.InputHeight + theme.BorderWidth * 2}px`,
        height: theme.InputHeight + theme.BorderWidth * 2,
        boxSizing: "border-box",
        padding: [[0, 16]],
        color: Mixins.foregroundColor(theme, theme.PrimaryColor),
    },
    label: {
        composes: "label",
    },
    labelLeft: {
        paddingTop: "inherit",
        composes: "label-left",
        marginRight: "5px",
        textAlign: "left",
    },
    labelRight: {
        paddingTop: "inherit",
        composes: "label-right",
        marginLeft: "5px",
        textAlign: "left",
    },
    title: {
        fontWeight: "bold",
    },
    collapsibleGrid: {
        composes: "collapsible-grid",
        "& > div:last-child": {
            borderBottom: [[0.5, "solid", "#eeeeee"]],
        },
        ".image-choice__target:hover": {
            boxShadow: "initial",
        },
    },
    collapsibleGridContainer: {
        borderTop: [[0.5, "solid", "#eeeeee"]],
    },
    collapsibleGridHeader: {
        composes: "collapsible-grid__header",
        position: "relative",
        padding: [[15, 0, 15, 0]],
        fontWeight: 700,
        cursor: "pointer",
    },
    collapsibleGridHeaderCollapse: {
        composes: "collapsible-grid__header--collapse",
        "& svg": {
            transform: "rotate(180deg)",
        },
    },
    collapsibleGridArrow: {
        composes: "collapsible-grid__arrow",
        position: "absolute",
        transition: [["transform", "400ms", "ease-in-out"]],
        top: 0,
        right: 0,
        bottom: 0,
        fontSize: theme.TextFontSize,
        margin: "auto",
        marginRight: 12,
    },
    collapsibleGridSeparator: {
        composes: "collapsible-grid__separator",
        padding: [[15, 0, 15, 0]],
        fontWeight: 700,
    },
    collapsibleGridFooter: {
        composes: "collapsible-grid__footer",
        padding: [[5, 0, 15, 0]],
    },
    choiceList: {
        composes: "choice-list",
    },
}));
